import axios from "axios";
import config from "../../config/local-config";
import apiConfig from "../../config/api-config";

const getTermsOfUse = () => {
  const version = "v1";
  const serviceName = "static";
  const apiUrl = `${apiConfig.apiURL}/${version}/${serviceName}/`;

  const site = `${config.hydra.site}`;
  const URI = `/terms-of-use`;

  let body = {
    domain: site,
    uri: URI
  };

  return axios.get(apiUrl, {
    params: body,
    headers: { apikey: apiConfig.apiKey }
  });
};

const getPrivacyPolicy = () => {
  const version = "v1";
  const serviceName = "static";
  const apiUrl = `${apiConfig.apiURL}/${version}/${serviceName}/`;

  const site = `${config.hydra.site}`;
  const URI = `/privacy-policy`;

  let body = {
    domain: site,
    uri: URI
  };

  return axios.get(apiUrl, {
    params: body,
    headers: { apikey: apiConfig.apiKey }
  });
};

const getShippingPolicy = () => {
  const version = "v1";
  const serviceName = "static";
  const apiUrl = `${apiConfig.apiURL}/${version}/${serviceName}/`;

  const site = `${config.hydra.site}`;
  const URI = `/customer/policies`;

  let body = {
    domain: site,
    uri: URI
  };

  return axios.get(apiUrl, {
    params: body,
    headers: { apikey: apiConfig.apiKey }
  });
};
export { getTermsOfUse, getPrivacyPolicy, getShippingPolicy };
